import { Avatar, Theme, useTheme } from "@mui/material";

interface totalMarksProps {
    outOf: number;
    isBottomCorner: boolean;
}

export const totalMarksStyle = {
    borderStyle: "solid",
    borderWidth: "1px",
    borderColor: "#999",
    color: "#000",
    width: "25px",
    height: "25px",
    margin: "0 10px 0 10px",
}

export const TotalMarks = (props: totalMarksProps) => {
    const theme = useTheme<Theme>();

    return (
        <Avatar
        sx={{
                fontSize: props.outOf >= 10 ? 12 : 14,
                backgroundColor: theme.bee.barBackgroundLight,
                ...totalMarksStyle
            }}>
            /{props.outOf}
        </Avatar>
    )
}